import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { initialContact } from '../initialState'

const locationsContact = createSlice({
  name: 'locationsContact',
  initialState: initialContact,
  reducers: {
    addContact: (state, action: PayloadAction<any>) => {
      const { contactKey = '', data } = action.payload
      const oldContacts = state.contacts[contactKey] || []
      state.contacts = {
        ...state.contacts,
        [contactKey]: [...oldContacts, data],
      }
    },
    updateLocationContact: (state: any, action: PayloadAction<any>) => {
      state.locationsContact = action.payload
    },
    removeLocationContact: (state: any) => {
      state.locationsContact = null
    },
    setIsContactPickup: (state: any, action: PayloadAction<any>) => {
      state.isContactPickup = action.payload
    },
    setIsContactDestination: (state: any, action: PayloadAction<any>) => {
      state.isContactDestination = action.payload
    },
  },
})
export const contactAction = locationsContact.actions
export default locationsContact
